import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.256}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 10446 17599"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541857376">
        <path
          d="M2260 11347c-14-2909 6-4873-2-7783-4-1391 278-2501 1684-2619 1507-127 2677-69 3182 1104-21 18-49 41-64 52l-386 261c-174 106-244 153-361 240-284 210-453 324-660 551-447 492-632 943-637 1862l1755 11c252 476 185 926 1010 895 749-28 667-436 910-904h1755c-9-1767-963-2214-2106-2917-723-444-661-1924-2778-2067-999-67-2051-73-2845 384C979 1417 1379 3340 1379 5687l-1 5659 882 1zM0 17599h3638v-910c-342-5-246 54-471-101 5-909 2-1820 2-2729 0-879 315-2157-630-2157-2461 0-2069-161-2069 2157 0 3200 165 2820-470 2830v910z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
